import React, { Component } from 'react';
import { Checkbox } from '~/native-ui/Checkbox';
import { ReadonlyField } from '~/native-ui/Fields/ReadonlyField';

export class BoolField extends React.Component {
    static propTypes = {};

    onChange = (isChecked, event) => {
        if (this.props.isReadonly) {
            return;
        }
        this.props.onChange(isChecked, event);
    };

    renderCheckbox() {
        return (
            <Checkbox
                checked={this.props.value}
                disabled={!this.props.editable || this.props.isProtected}
                onChange={this.onChange}
                readonly={this.props.isReadonly}
                label={!this.props.isReadonly ? this.props.title : null}
                tooltip={this.props.tooltip}
            >
                {this.props.children}
            </Checkbox>
        );
    }

    renderReadonly = () => {
        let { value, trans, title } = this.props;

        return (
            <ReadonlyField
                className={this.props.className}
                tooltip={this.props.tooltip}
                label={title}
                value={value ? trans('yes') : trans('no')}
            />
        );
    };

    render() {
        if (this.props.isReadonly) {
            return this.renderReadonly();
        }

        return this.renderCheckbox();
    }
}
